<div
  class="flow-page-layout"
  [attr.data-scroll-mode]="scrollMode()"
  [attr.data-content-scroll-owner]="contentScrollOwner()"
  [style.--flow-page-layout-header-height.px]="measuredHeaderHeight()"
  [style.--flow-page-layout-actions-top.px]="actionsTop()"
>
  <header #headerHost class="flow-page-layout__header">
    <ng-content select="[header]" />
  </header>

  <div class="flow-page-layout__actions">
    <ng-content select="[actions]" />
  </div>

  <main class="flow-page-layout__content">
    <div class="flow-page-layout__content-frame">
      <ng-content />
    </div>
  </main>
</div>
